<div class="checkout-group">
  <div class="checkout-group-title">
    {{ 'checkout.group.payment.title' | cxTranslate }}
  </div>
  <form [formGroup]="paymentModeForm" *ngIf="paymentModes">
    <div class="checkout-group-body d-flex">
      <!-- Payment Mode Dropdown-->
      <div class="payment-group-info payment-group-info-dropdown">
        <mat-form-field appearance="outline" class="mat-primary mat-form-field">
          <mat-label>{{ 'checkout.group.payment.paymentModeTitle' | cxTranslate }}</mat-label>
          <mat-select
            appearance="outline"
            formControlName="paymentMode"
            disableOptionCentering
            panelClass="checkout-select"
            (selectionChange)="onSelectPayment()"
          >
            <mat-option *ngFor="let mode of paymentModes" [value]="mode">
              {{ mode.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Payment Terms -->
      <div class="payment-group-info">
        <span class="payment-title">{{ 'checkout.group.payment.paymentModeTerms' | cxTranslate }}</span>
        <span class="payment-value">{{ paymentTerms }}</span>
      </div>
    </div>
  </form>
</div>
